/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DocumentType = {
    ID_CARD: 'ID_CARD',
    RESIDENCE_PERMIT: 'RESIDENCE_PERMIT',
    DRIVER_LICENSE: 'DRIVER_LICENSE',
    MEDICAL_CARD: 'MEDICAL_CARD'
} as const;
export type DocumentType = typeof DocumentType[keyof typeof DocumentType];

